import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'sub-technology',
  templateUrl: './sub-technology.component.html',
  styleUrls: ['./sub-technology.component.sass']
})
export class SubTechnologyComponent implements OnInit {
  @Input() name: string;
  @Input() content: string;
  
  constructor() { }

  ngOnInit() {
  }

}
